import React, { useContext, useState, useEffect } from "react";
import styled, { css } from "styled-components";
import PropTypes from "prop-types";
import { isEmpty } from 'lodash';
import { Text } from "@dhxete/text";
import Circle from "./Circle/Circle";
import { LoadScript } from './LoadScript';
import { useAppContext } from "../../Context";

const Agent = ({
  className,
  id
}) => {
  const {
    state: {
      langStrings,
      userSession,
      hasAgentLoaded,
      isAgentAvailable
    },
    // eslint-disable-next-line no-unused-vars
    dispatch,
    chatDetails,
    chatSubject,
    chatDescription,
    handleAgentLoad,
    handleAgentAvailable,
    handleAgentAnalytics
  } = useAppContext(); // const deploymentUrl = 'https://c.la1-c2cs-dfw.salesforceliveagent.com/content/g/js/43.0/deployment.js';
  // const initUrl = 'https://d.la1-c2cs-dfw.salesforceliveagent.com/chat';
  // const initParamOne = '572300000001aGj';
  // const initParamTwo = '00DV00000088iEz';

  const deploymentUrl = chatDetails.deploymentUrl;
  const liveAgentId = chatDetails.liveAgentId;
  const initUrl = chatDetails.initUrl;
  const initParamOne = chatDetails.initParamOne;
  const initParamTwo = chatDetails.initParamTwo;
  const liveagentOnlineButtonId = 'liveagent_button_online_' + liveAgentId;
  const liveagentOfflineButtonId = 'liveagent_button_offline_' + liveAgentId;
  const [agentAvailable, setAgentAvailable] = useState(isAgentAvailable);
  const [loaded, error] = LoadScript(deploymentUrl);
  useEffect(() => {
    if (loaded && !hasAgentLoaded) {
      if (!window._laq) {
        window._laq = [];
      }

      window.liveagent.enableLogging();
      window.liveagent.addCustomDetail('fname', !isEmpty(userSession.first) ? userSession.first : '');
      window.liveagent.addCustomDetail('lname', !isEmpty(userSession.last) ? userSession.last : '');
      window.liveagent.addCustomDetail('Contact Email', !isEmpty(userSession.email) ? userSession.email : '');

      try {
        window.liveagent.addCustomDetail('Case Subject', chatSubject);
        window.liveagent.addCustomDetail('Case Status', 'New', false);
        window.liveagent.addCustomDetail('Case Type', chatDetails.typeId);
        window.liveagent.addCustomDetail('Case Topic', chatDetails.topic);
        window.liveagent.addCustomDetail('Origin', chatDetails.widgetOrigin);
        window.liveagent.addCustomDetail('Case Sub Origin', chatDetails.chatSubOrigin);
        window.liveagent.addCustomDetail('How can I help you ?', chatDescription);
        console.log('chat init window live agent', window.liveagent);

        window._laq.push(function () {
          window.liveagent.addButtonEventHandler(liveAgentId, function (e) {
            console.log('E', e);

            if (e === window.liveagent.BUTTON_EVENT.BUTTON_UNAVAILABLE) {
              setAgentAvailable(false);
              handleAgentAvailable(false);
            }

            if (e === window.liveagent.BUTTON_EVENT.BUTTON_AVAILABLE) {
              setAgentAvailable(true);
              handleAgentAvailable(true);
            }

            if (e === window.liveagent.BUTTON_EVENT.BUTTON_ACCEPTED) {
              handleAgentAnalytics();
            }
          });
          window.liveagent.showWhenOnline(liveAgentId, document.getElementById(liveagentOnlineButtonId));
          window.liveagent.showWhenOffline(liveAgentId, document.getElementById(liveagentOfflineButtonId));
        });

        window.liveagent.init(initUrl, initParamOne, initParamTwo);
        window.liveagent.setChatWindowHeight(680);
        window.liveagent.setChatWindowWidth(520);
        handleAgentLoad();
      } catch (e) {
        console.log('Error:', e);
      }
    }
  }, [loaded]);

  const handleOnClick = event => {
    event.preventDefault();

    if (agentAvailable) {
      dispatch({
        type: "GO_TO_AGENT_AVAILABLE_PAGE"
      });
      window.liveagent.startChat(liveAgentId);
    }
  };

  return /*#__PURE__*/React.createElement("div", {
    className: className,
    onClick: handleOnClick,
    id: id
  }, /*#__PURE__*/React.createElement(Text, {
    fontWeight: "bold"
  }, langStrings.contactOptions.chatWithAgent), /*#__PURE__*/React.createElement(Circle, {
    isAgentAvailable: agentAvailable,
    langStrings: langStrings
  }));
};

Agent.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string
};
export default styled(Agent)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-flow: column;
  width: calc(100% - 50px);
  height: 80px;
  background: #f7fcfe;
  border: 1px #0695d7 solid;
  cursor: pointer;
  margin-bottom: 10px;
`;